import { componentType } from '../../../../../../../hooks/useMixpanel';
import FormContent from './FormContent';
import { ReactComponent as AttachIcon } from '../../../../../../../assets/icons/invitationIcons/attachIcon.svg';

export const SMSContent = ({
  patientUuid,
  mixpanelComponent,
}: {
  patientUuid?: string;
  mixpanelComponent?: componentType;
}) => {
  return (
    <div>
      <div className="flex text-primary-p3 mb-4 pb-1">
        <AttachIcon className="shrink-0" />
        <span className="font-semibold leading-6 pl-2">
          Send the patient a link via SMS
        </span>
      </div>
      <FormContent patientUuid={patientUuid} mixpanelComponent={mixpanelComponent} />
    </div>
  );
};
